import script from "./LabelsTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./LabelsTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./LabelsTableLoader.vue?vue&type=style&index=0&id=2f6c2822&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f6c2822"]])

export default __exports__